import type { CityConfig } from "../city-template/types";

export const tylerConfig: CityConfig = {
  city: "Tyler",
  state: "Texas",
  stateAbbr: "TX",
  slug: "tyler",
  route: "/cities/tyler",
  title: "Emergency Passport Tyler, TX — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Tyler, TX — as fast as 24 hours. Serving Smith County and East Texas. A+ BBB rated registered State Dept. courier serving the Rose Capital and Piney Woods region. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Tyler, TX",
  heroSubtitle: "East Texas business trip to Mexico with two weeks notice? Rose Festival cruise and your passport expired? UT Tyler student studying abroad? We help Tyler residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Tyler%20Texas%20East%20Texas%20Rose%20Capital%20cityscape%20with%20rose%20gardens%20and%20brick%20streets%20downtown%20historic%20architecture%20surrounded%20by%20piney%20woods%20forest%20landscape%20at%20golden%20hour%20warm%20southern%20sunset%20colors%20professional%20drone%20photography%20vibrant%20warm%20tones%20natural%20beauty&width=1800&height=700&seq=tyler-hero-tx-2026&orientation=landscape",
  heroImageAlt: "Tyler Texas East Texas Rose Capital cityscape with piney woods at golden hour",
  geoPosition: "32.3513;-95.3011",
  geoPlacename: "Tyler, Texas",
  regionalAgency: {
    name: "Houston Passport Agency",
    address: "1919 Smith Street, Suite 700, Houston, TX 77002",
    distance: "Located in downtown Houston — approximately 200 miles south of Tyler via US-69",
  },
  nearbyCitiesZips: [
    { name: "Tyler", zips: "75701–75713" },
    { name: "Whitehouse", zips: "75791" },
    { name: "Lindale", zips: "75771" },
    { name: "Bullard", zips: "75757" },
    { name: "Jacksonville", zips: "75766" },
    { name: "Kilgore", zips: "75662" },
    { name: "Longview", zips: "75601–75606" },
    { name: "Henderson", zips: "75652, 75653, 75654" },
    { name: "Athens", zips: "75751, 75752" },
    { name: "Palestine", zips: "75801, 75802, 75803" },
    { name: "Nacogdoches", zips: "75961–75965" },
    { name: "Lufkin", zips: "75901–75904" },
    { name: "Mineola", zips: "75773" },
    { name: "Canton", zips: "75103" },
    { name: "Van", zips: "75790" },
    { name: "Gladewater", zips: "75647" },
    { name: "Marshall", zips: "75670, 75671, 75672" },
    { name: "Texarkana", zips: "75501–75505" },
    { name: "Dallas", zips: "75201–75299" },
    { name: "Shreveport", zips: "71101–71166" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent East Texas departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "East Texas Coverage", desc: "Serving Tyler, Longview, Nacogdoches, and the Piney Woods" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Dallas, TX", route: "/cities/dallas" },
    { name: "Fast passport renewal in Houston, TX", route: "/cities/houston" },
    { name: "Emergency passport help in Shreveport, LA", route: "/cities/shreveport" },
    { name: "Urgent passport services in Longview, TX", route: "/cities/longview" },
    { name: "Same-day passport help in Austin, TX", route: "/cities/austin" },
    { name: "Passport courier services in Fort Worth, TX", route: "/cities/fort-worth" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Tyler remotely via secure courier. We do not have a walk-in office in Tyler — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Smith County and the East Texas Piney Woods region.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Smith County and the East Texas Piney Woods region including Gregg, Cherokee, Henderson, and Anderson counties",
  serviceAreaIntro: "From the historic brick streets and Rose Garden of Tyler to the oil-rich communities of Kilgore and Longview, from the charming downtown of Henderson to the college town of Nacogdoches, from the antique shops of Canton and Mineola to the dogwood trails of Palestine — Fast Passport Center serves the entire East Texas Piney Woods region. We regularly help travelers from Smith County, Gregg County, and across East Texas get their passports fast without the 200-mile drive to Houston.",
  nearbyCitiesIntro: "We serve all Tyler neighborhoods and the surrounding East Texas area including Whitehouse, Lindale, Bullard, Jacksonville, Kilgore, Longview, Henderson, Athens, Palestine, Nacogdoches, Lufkin, Mineola, Canton, Van, Gladewater, Marshall, and Texarkana. If you are anywhere in Smith County, the Piney Woods, or Deep East Texas, we have you covered.",
  howItWorksIntro: "Most Tyler travelers complete everything online and ship documents overnight. No need to drive to Houston or wait in line at the regional agency.",
  mistakesIntro: "Tyler travelers often face a 3.5-hour drive to the nearest regional passport agency in Houston. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Tyler and Smith County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Tyler? Here are the most common ones we hear from East Texas travelers.",
  statePageRoute: "/states/texas",
  statePageName: "Texas",
  dmvWebsite: "https://www.dps.texas.gov",
  dmvLabel: "Texas DPS — Driver License Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Tyler travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Rebecca H.",
      location: "Tyler, TX",
      rating: 5,
      text: "My passport expired right before the Rose Festival cruise. Fast Passport Center had my renewal in 28 hours. I never left Tyler. Their East Texas service saved our family vacation.",
      service: "Passport Renewal",
    },
    {
      name: "Mark D.",
      location: "Longview, TX",
      rating: 5,
      text: "Emergency passport for a family medical emergency in Mexico City. Got it in 30 hours. Fast Passport Center handled everything — I didn't have to drive to Houston. Life-saving service.",
      service: "Emergency Passport",
    },
    {
      name: "Sandra W.",
      location: "Whitehouse, TX",
      rating: 5,
      text: "First passport for my 10-year-old before our trip to Canada. Fast Passport Center walked us through every form and had her passport in 4 days. So easy for East Texas families.",
      service: "Child Passport",
    },
    {
      name: "James K.",
      location: "Tyler, TX",
      rating: 5,
      text: "UT Tyler study abroad program in Spain. Lost my passport 4 days before departure. Fast Passport Center had a replacement in 26 hours. Absolutely incredible service for Piney Woods students.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "tyler-1",
      name: "Tyler Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2100 W Martin Luther King Jr Blvd",
      city: "Tyler",
      state: "TX",
      zip: "75702",
      phone: "(903) 595-3111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Tyler",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Tyler facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "tyler-2",
      name: "Tyler Southeast Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2620 S Broadway Ave",
      city: "Tyler",
      state: "TX",
      zip: "75701",
      phone: "(903) 595-3119",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Tyler",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves South Tyler and surrounding area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "tyler-3",
      name: "Smith County District Clerk",
      type: "Court Clerk Passport Acceptance",
      address: "100 N Broadway Ave",
      city: "Tyler",
      state: "TX",
      zip: "75702",
      phone: "(903) 590-1660",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Tyler Courthouse",
      website: "https://www.smith-county.com/government/courts/district-clerk",
      websiteLabel: "Smith County District Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "tyler-4",
      name: "Longview Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 E Methvin St",
      city: "Longview",
      state: "TX",
      zip: "75601",
      phone: "(903) 753-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "40 miles east of Tyler",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Regional facility serving Gregg County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "tyler-5",
      name: "Henderson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 E Main St",
      city: "Henderson",
      state: "TX",
      zip: "75652",
      phone: "(903) 657-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles southeast of Tyler",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Rusk County and southern Smith County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "tyler-6",
      name: "Nacogdoches Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 E Pilar St",
      city: "Nacogdoches",
      state: "TX",
      zip: "75961",
      phone: "(936) 564-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "60 miles south of Tyler",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Nacogdoches County and SFA students. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Fastest Processing", agency: "24–48 hours", fpc: "Same day (emergencies only)" },
    { feature: "Appointment Required", agency: "No", fpc: "Yes — call NPIC, limited slots" },
    { feature: "Processing Speed", agency: "Guaranteed turnaround", fpc: "Same-day if approved (rare)" },
    { feature: "Document Review", agency: "Yes — we check before submission", fpc: "No — rejected if wrong" },
    { feature: "Travel to Agency", agency: "No — ship from home", fpc: "Yes — 3.5 hour drive to Houston" },
    { feature: "Agent Support", agency: "Yes — dedicated agent assigned", fpc: "No — government clerk only" },
    { feature: "Status Updates", agency: "Yes — daily email updates", fpc: "No — no tracking provided" },
    { feature: "Guaranteed Timing", agency: "Yes — contractual turnaround", fpc: "No — subject to availability" },
    { feature: "East Texas Knowledge", agency: "Yes — local Piney Woods expertise", fpc: "Generic" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Tyler photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Smith County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Tyler applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Houston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many East Texas families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Tyler travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Tyler." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Tyler address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Tyler before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Tyler for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 3.5-hour drive to Houston." },
    { q: "How fast can I renew my passport in Tyler?", a: "Fast Passport Center offers fast passport renewal in Tyler in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Tyler?", a: "The nearest regional passport agency to Tyler is the Houston Passport Agency, approximately 200 miles south via US-69. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Tyler without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Tyler?", a: "Same-day passport appointments are only available at the Houston Regional Passport Agency — approximately 3.5 hours from Tyler — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Smith County and East Texas residents." },
    { q: "Do you serve the entire East Texas region?", a: "Absolutely. Fast Passport Center serves the entire East Texas Piney Woods region including Tyler, Whitehouse, Lindale, Bullard, Jacksonville, Kilgore, Longview, Henderson, Athens, Palestine, Nacogdoches, Lufkin, and surrounding areas. Our courier service works seamlessly from any address in Smith County, Gregg County, and Deep East Texas." },
    { q: "Can I expedite a child passport in Tyler?", a: "Yes. Fast Passport Center expedites child passports in Tyler for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk East Texas families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Tyler with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Houston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Tyler", address: "2100 W Martin Luther King Jr Blvd, Tyler, TX 75702", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Tyler", address: "2620 S Broadway Ave, Tyler, TX 75701", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Tyler", address: "6801 S Broadway Ave, Tyler, TX 75703", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Longview", address: "201 E Methvin St, Longview, TX 75601", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Henderson", address: "201 E Main St, Henderson, TX 75652", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Tyler", address: "4601 S Broadway Ave, Tyler, TX 75703", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Texas DPS — Tyler",
      address: "4700 University Blvd, Tyler, TX 75707",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Texas DPS — Longview",
      address: "414 N Fredonia St, Longview, TX 75601",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Gregg County and East Texas. REAL ID available.",
      featured: false,
    },
    {
      name: "Texas DPS — Jacksonville",
      address: "506 S Jackson St, Jacksonville, TX 75766",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Cherokee County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "TYR",
      name: "Tyler Pounds Regional Airport",
      distance: "5 miles west of downtown Tyler",
      address: "700 Skyway Blvd, Tyler, TX 75704",
      note: "Regional airport serving East Texas. Direct flights to Dallas-Fort Worth via American Eagle. About 10 minutes from downtown Tyler.",
      flightUrl: "https://www.cityoftyler.org/government/departments/airport",
      flightLabel: "TYR Airport",
      featured: true,
    },
    {
      code: "GGG",
      name: "East Texas Regional Airport",
      distance: "45 miles east of Tyler",
      address: "269 Terminal Cir, Longview, TX 75603",
      note: "Serves Longview and East Texas. Direct flights to Dallas-Fort Worth. About 50 minutes from Tyler.",
      flightUrl: "https://www.easttexasairport.com/",
      flightLabel: "GGG Airport",
      featured: false,
    },
    {
      code: "DFW",
      name: "Dallas/Fort Worth International Airport",
      distance: "110 miles west of Tyler",
      address: "2400 Aviation Dr, DFW Airport, TX 75261",
      note: "Major international hub. American Airlines hub with direct flights worldwide. About 1 hour 45 minutes from Tyler.",
      flightUrl: "https://www.dfwairport.com/",
      flightLabel: "DFW Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Texas Department of State Health Services Vital Statistics. Online, mail, or in-person options available for Smith County.",
      url: "https://dshs.texas.gov/vs/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Texas DSHS Vital Statistics. Required for estate and legal matters in East Texas.",
      url: "https://dshs.texas.gov/vs/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Smith County Clerk. Certified copies available for name changes and legal purposes in Tyler.",
      url: "https://www.smith-county.com/government/courts/county-clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Smith County District Clerk. Required for name change passport corrections and legal documentation.",
      url: "https://www.smith-county.com/government/courts/district-clerk",
    },
  ],
};